import {
  getMethodWithToken,
  getMethodWithParamWithToken,
} from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_FAILURE = 'GET_USERS_LIST_FAILURE';

// Action Creators
export const fetchGetUsersList = () => ({
  type: GET_USERS_LIST,
});

export const fetchGetUsersListSuccess = (data) => ({
  type: GET_USERS_LIST_SUCCESS,
  payload: data,
});

export const fetchGetUsersListFailure = (error) => ({
  type: GET_USERS_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getUsersListCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetUsersList(data, external));
    try {
      let response;

      // Use getMethodWithParamWithToken if search parameter exists, otherwise use getMethodWithToken
      // Following the same pattern as specialist details API
      if (data?.search) {
        response = await getMethodWithParamWithToken(url.getUsersList, {
          search: data.search,
        });
      } else {
        response = await getMethodWithToken(url.getUsersList);
      }

      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetUsersListSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetUsersListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetUsersListFailure(error.message));
      if (external && external.toast) {
        external.handleToastError(error.response);
      }
    }
  };
};
